/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cv.assignments.rpc.AssigneeService
 */

export const getAssigneesRpc = {
  serviceName: 'com.hubspot.cv.assignments.rpc.AssigneeService',
  rpcName: 'getAssignees',
  auth: 'app',
  fingerprint: 'TKi5uu77bCFLCYV0gdE0CnXY1h-TEml7',
  na1Only: false,
  isStreaming: false
};
export const getAssigneeRpc = {
  serviceName: 'com.hubspot.cv.assignments.rpc.AssigneeService',
  rpcName: 'getAssignee',
  auth: 'app',
  fingerprint: '8l6Kscd1sr1I4qzUBbXayXXY1h-TEml7',
  na1Only: false,
  isStreaming: false
};